import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';

export const ToolbarWrapper = styled.div`
  border-top: ${spacing.single} solid ${colors.borderPrimarySubtle};
  border-bottom: ${spacing.single} solid ${colors.borderPrimarySubtle};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${spacing.double};
`;

export const SegmentationResultsWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;
